class FaqSection extends HTMLElement {
  constructor() {
    super()

    this.cateories = this.querySelectorAll('.faq-page-categories__link')

    this.handleClickLink = this.handleClickLink.bind(this)
  }

  connectedCallback() {
    this.cateories.forEach(category => {
      category.addEventListener('click', (e) => {
        e.preventDefault()
        this.handleClickLink(category.getAttribute('href'))
      })
    })
  }

  handleClickLink(selector) {
    const targetObj = this.querySelector(selector)
    window.scrollTo({
      top: targetObj.offsetTop - 120,
      behavior: 'smooth',
    })
  }
}

customElements.define('faq-section', FaqSection)
